module.exports = __webpack_public_path__ + "static/media/Brittany Howard - He Loves Me (Official Audio).515d850c.mp3";